import { TagsInput } from '@chakra-ui/react';

type VTagsInputRootProviderProps = TagsInput.RootProviderProps;

const VTagsInputRootProvider = ({ size = 'xs', ...props }: VTagsInputRootProviderProps) => (
  <TagsInput.RootProvider size={size} {...props} />
);

const VTagsInput = {
  RootProvider: VTagsInputRootProvider,
  Control: TagsInput.Control,
  Item: TagsInput.Item,
  ItemPreview: TagsInput.ItemPreview,
  ItemText: TagsInput.ItemText,
  ItemDeleteTrigger: TagsInput.ItemDeleteTrigger,
  Input: TagsInput.Input,
  ClearTrigger: TagsInput.ClearTrigger,
};

export { useTagsInput } from '@chakra-ui/react';
export default VTagsInput;
export type { VTagsInputRootProviderProps };
